import { Button, ButtonRow } from '@ksyos/design-system';
import type { IQuestionnaireFormProps } from '../../../Questionnaire';
import { essQuestionOptions } from '../../../../../../../common/validation/customControls/somnology';
import { Step } from '../../../../../elements/atoms/step/Step';
import { CustomContainer } from '../../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../../elements/molecules/stack/Stack';
import { PageIntro } from '../../../../../elements/organisms/pageIntro/PageIntro';
import { QuestionnaireRadioGroup } from '../../../../../elements/organisms/questionnaireRadioGroup/QuestionnaireRadioGroup';
import { StyledFormGroup } from '../../../../../elements/organisms/StyledFormGroup/StyledFormGroup';

export function Step1(props: IQuestionnaireFormProps) {
    return (
        <>
            <PageIntro
                subtitle={
                    'Hoe makkelijk doezel je weg of val je in slaap in de volgende situaties? Het gaat niet enkel om moe zijn, maar om een gevoel van slaperigheid. \n \n Heb je een van de onderstaande situaties recentelijk niet meegemaakt, probeer je dan in te denken hoe je je zou voelen.'
                }
                title="ESS: vragen deel 1/2"
            />

            <CustomContainer>
                <Stack>
                    <Step>1/8</Step>
                    <StyledFormGroup
                        hasErrors={props.errors.has('whenReading')}
                        label="Wanneer ik zit te lezen"
                        layout="vertical"
                    >
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="whenReading"
                            questionnaireOptions={essQuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>

                <Stack>
                    <Step>2/8</Step>
                    <StyledFormGroup
                        hasErrors={props.errors.has('whenWatchingTv')}
                        label="Wanneer ik tv kijk"
                        layout="vertical"
                    >
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="whenWatchingTv"
                            questionnaireOptions={essQuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>

                <Stack>
                    <Step>3/8</Step>
                    <StyledFormGroup
                        hasErrors={props.errors.has('inAPublicEnvironment')}
                        label="Wanneer ik mij in een publieke omgeving bevind (bijvoorbeeld schouwburg of vergadering)"
                        layout="vertical"
                    >
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="inAPublicEnvironment"
                            questionnaireOptions={essQuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>

                <Stack>
                    <Step>4/8</Step>
                    <StyledFormGroup
                        hasErrors={props.errors.has('sittingInACarAsPassenger')}
                        label="Wanneer ik een uur lang zonder onderbreking als passagier in een auto zit"
                        layout="vertical"
                    >
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="sittingInACarAsPassenger"
                            questionnaireOptions={essQuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>
                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.validateAndGoToNextStep}
                        variant="solid"
                        width="full-below-small"
                    >
                        Verder
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
